import { render, staticRenderFns } from "./StudyStringModal.vue?vue&type=template&id=35f516e0&scoped=true&"
import script from "./StudyStringModal.vue?vue&type=script&lang=js&"
export * from "./StudyStringModal.vue?vue&type=script&lang=js&"
import style0 from "./StudyStringModal.vue?vue&type=style&index=0&id=35f516e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f516e0",
  null
  
)

export default component.exports